import { ReactNode } from "react";
import { Phone } from "lucide-react";
import { Link } from "@/lib/router-compat";

interface PageHeroProps {
  label: string;
  /** H1 content. Use <span style={{ color: "#FAC8C8" }}> for the location accent. */
  h1: ReactNode;
  subheadline: string;
}

const PHONE = "856-200-3127";
const TEL = "tel:8562003127";

const PageHero = ({ label, h1, subheadline }: PageHeroProps) => (
  <section
    className="relative flex items-center"
    style={{
      background: "linear-gradient(90deg, #6B1414 0%, #8B1A1A 100%)",
      minHeight: 300,
      padding: "40px 20px",
    }}
  >
    <div
      className="absolute inset-0 opacity-[0.07] pointer-events-none"
      style={{
        backgroundImage: "radial-gradient(#FAF4F0 1px, transparent 1px)",
        backgroundSize: "22px 22px",
      }}
      aria-hidden="true"
    />
    <div className="relative mx-auto text-center w-full" style={{ maxWidth: 760 }}>
      <p
        style={{
          color: "#FAF4F0",
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: "0.15em",
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        {label}
      </p>
      <h1
        className="font-display text-[30px] md:text-[40px]"
        style={{ color: "#FFFFFF", fontWeight: 700, lineHeight: 1.15, margin: 0 }}
      >
        {h1}
      </h1>
      <p
        className="text-[15px] md:text-[17px]"
        style={{
          color: "#FAF4F0",
          textAlign: "center",
          lineHeight: 1.6,
          marginTop: 12,
          marginBottom: 24,
        }}
      >
        {subheadline}
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center">
        <a
          href={TEL}
          aria-label={`Call Cherry Hill Recovery Center at ${PHONE}`}
          className="inline-flex items-center justify-center gap-2"
          style={{
            background: "#FAF4F0",
            color: "#8B1A1A",
            borderRadius: 50,
            padding: "13px 28px",
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
          }}
        >
          <Phone size={16} /> Call {PHONE}
        </a>
        <Link
          to="/verify-insurance"
          aria-label="Verify your insurance coverage"
          className="inline-flex items-center justify-center"
          style={{
            border: "2px solid #FAF4F0",
            color: "#FAF4F0",
            background: "transparent",
            borderRadius: 50,
            padding: "11px 28px",
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
          }}
        >
          Verify Your Insurance
        </Link>
      </div>
    </div>
  </section>
);

export default PageHero;
